export const EMPTY = -1;
export const OPTION_ALL_KEY = 'searchClientOwnerAll';
export const DEBOUNCE_TIME = 500;
export const MIN_SEARCH_LENGTH = 3;
